import { Home, ClipboardCheck, BookOpen, TrendingUp, User, Utensils, LogOut } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';

const navItems = [
  { icon: Home, label: 'Inicio', path: '/app' },
  { icon: ClipboardCheck, label: 'Check-in', path: '/app/checkin' },
  { icon: BookOpen, label: 'Protocolo', path: '/app/protocolo' },
  { icon: Utensils, label: 'Recetas', path: '/app/receitas' },
  { icon: TrendingUp, label: 'Progreso', path: '/app/progresso' },
];

const DesktopSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuth();

  return (
    <aside className="hidden md:flex flex-col w-64 min-h-screen bg-card border-r border-border p-4">
      <div className="mb-8 px-3">
        <h1 className="text-xl font-heading font-bold text-primary">🍃 Intestino Leve</h1>
        <p className="text-xs text-muted-foreground mt-1">Más ligereza en tu día</p>
      </div>
      <nav className="flex-1 space-y-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/app' && location.pathname.startsWith(item.path));
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                "flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm font-medium transition-colors",
                isActive
                  ? "bg-secondary text-secondary-foreground"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </button>
          );
        })}
      </nav>
      <button
        onClick={() => signOut()}
        className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
      >
        <LogOut className="h-5 w-5" />
        Salir
      </button>
    </aside>
  );
};

export default DesktopSidebar;